// extracted by mini-css-extract-plugin
export default {"LoadingContainer":"n6XAOsdi","LoadingText":"ykIvto9h","LoadingSpinner":"tN4917gA","TabContainer":"CfD748_5","ReviewMessageContainer":"chA2C5Nb"};